module.exports = __webpack_public_path__ + "img/partner-8.e0687a12.png";